<template>
  <div class="font-italic mt-2 mt-3 obs-start-hour">
    Obs.: Será utilizada <span class="font-weight-bold">"{{formattedStartHour}}"</span> como hora inicial do ciclo diário de irrigação, pois foi definido no cadastro de configurações do manejo.
  </div>
</template>

<script>
import getStartHour from "@/common/components/InitialManagementHour/getStartHour.vue";

export default {
  mixins: [getStartHour]
}
</script>

<style scoped>
.obs-start-hour {
  font-size: 14px;
}
</style>